import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "white",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M3 9v6h4l5 5V4L7 9H3z"
}), /*#__PURE__*/React.createElement("line", {
  x1: "16",
  y1: "8",
  x2: "20",
  y2: "12"
}), /*#__PURE__*/React.createElement("line", {
  x1: "20",
  y1: "8",
  x2: "16",
  y2: "12"
})), 'Muted', {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24'
});